import React from 'react';
import Label from 'src/modules/shared/components/atoms/inputs/label';
import { Text } from 'src/modules/shared/components/atoms/text';

interface FieldWrapperProps {
  fieldKey: string;
  fieldTitle: string;
  fieldDescription?: string;
  isRequired: boolean;
  children: React.ReactNode;
}

/**
 * Provides a consistent wrapper for all form fields with label and description
 */
export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  fieldKey,
  fieldTitle,
  fieldDescription,
  isRequired,
  children,
}) => {
  return (
    <div key={fieldKey} className="mb-4">
      <Label title={fieldTitle} required={isRequired}>
        {fieldTitle}
      </Label>
      {fieldDescription && (
        <Text size="small" color="neutral" className="mb-1">
          {fieldDescription}
        </Text>
      )}
      {children}
    </div>
  );
};
